<template>
        <div class="page-wrapper">
            <edit-astro-map-window
                    :visible="editWindow.visible"
                    :id="editWindow.id"
                    :name="editWindow.name"
                    @close-window="closeEditWindow"/>
            <delete-astro-map-window
                    :visible="deleteWindow.visible"
                    :id="deleteWindow.id"
                    :name="deleteWindow.name"
                    @close-window="closeDeleteWindow"/>
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>
                    <div class="container-right">
                        <div class="page-title cabinet-page-title visibility">Мои карты</div>
                        <div class="favorites-notice" v-if="!astroMaps || astroMaps.length == 0">У Вас нет сохраненных карт</div>
                        <div class="favorites-list" v-else>
                            <router-link class="item"
                                         v-for="(astroMap, i) in astroMaps"
                                         :to="{name: 'CardCalculate', query: { id: astroMap.id }}">
                                <div class="name">
                                    {{ astroMap.name }}
                                    <div class="icons">
                                        <i class="fa fa-pencil map-name-edit-btn" title="Переименовать карту"
                                           @click.prevent="showEditWindow(astroMap)"></i>
                                        <i class="fa fa-trash-o" title="Удалить"
                                           @click.prevent="showDeleteWindow(astroMap)"></i>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';
    import EditAstroMapWindow from '@/components/window/EditAstroMapWindow';
    import DeleteAstroMapWindow from '@/components/window/DeleteAstroMapWindow';

    const blankEditWindow = {
        visible: false,
        id: null,
        name: ''
    };

    export default {
        name: "Cabinet",

        components: {
            Header, Footer, UserMenu, EditAstroMapWindow, DeleteAstroMapWindow
        },

        data() {
            return {
                editWindow: Object.assign({}, blankEditWindow),
                deleteWindow: Object.assign({}, blankEditWindow)
            }
        },

        computed: {
            astroMaps() {
                return this.$store.getters.astroMaps;
            }
        },

        async created() {
            await this.loadAstroMaps();
        },

        methods: {
            loadAstroMaps() {
                this.$store.dispatch('listAstroMaps');
            },

            showEditWindow(astroMap) {
                Object.assign(this.editWindow, {
                    visible: true,
                    id: astroMap.id,
                    name: astroMap.name
                });
            },

            closeEditWindow(payload) {
                Object.assign(this.editWindow, blankEditWindow);
                if (!!payload.reload) {
                    this.loadAstroMaps();
                }
            },

            showDeleteWindow(astroMap) {
                Object.assign(this.deleteWindow, {
                    visible: true,
                    id: astroMap.id,
                    name: astroMap.name
                });
            },

            closeDeleteWindow(payload) {
                Object.assign(this.deleteWindow, blankEditWindow);
                if (!!payload.reload) {
                    this.loadAstroMaps();
                }
            }
        }
    }
</script>